
import {SubscriptionConfirmationActions} from './subscription.confirmation.actions';
import {SubscriptionConfirmationContext} from './subscription.confirmation.context';
import {AuthByPhoneComponent} from '../form/auth-by-phone/auth-by-phone.component';
import {SubscriptionResources} from '../../../../resources/subscription.resources';
import {SocialTrackService} from '../../../../services/social-track.service';
import {MyPaypalTransactionInfo} from '../../../../model/paypal.model';
import {AbstractSubscriptionContextService} from '../../../../services/abstract-subscription-context.service';
import {SessionDTO} from '@minutespourtoi/api-models/dist/models';


export interface SubscriptionConfirmationPayment {
  setUp(
    sessionDTO: SessionDTO,
    actions: SubscriptionConfirmationActions,
    context: SubscriptionConfirmationContext,
    referralCode: string,
    authByPhone: AuthByPhoneComponent): void

  pay(...args: Array<string>): Promise<any>
  setAuthByPhone(authByPhone: AuthByPhoneComponent)
}

export abstract class AbstractSubscriptionPayment implements SubscriptionConfirmationPayment {
  protected sessionDTO: SessionDTO
  protected actions: SubscriptionConfirmationActions
  protected context: SubscriptionConfirmationContext
  protected authByPhone: AuthByPhoneComponent
  protected subscriptionContextService: AbstractSubscriptionContextService
  protected referralCode: string

  protected constructor(protected subscriptionResources: SubscriptionResources,
                        protected platformId: any,
                        protected socialTrackService: SocialTrackService) {
  }

  protected checkPaymentAndPrice() {

    let isReady = true;
    if (this.subscriptionResources.calculatePrice.value()?.totalPrice === 0) {
      this.actions.failWithMessage("Le paiement est impossible si le prix est 0€.", null)
      isReady = false
    } else if (this.context.paymentContext()?.loading === true) {
      this.actions.failWithMessage("Un paiement est déja en cours, veuillez patienter", null)
      isReady = false
    }
    return isReady
  }

  protected checkContext(): boolean {
    if (this.context.confirmationForm && this.context.confirmationForm.invalid) {
      this.actions.failWithMessage("Veuillez saisir les informations demandées et accepter nos CGV et règles de confidentialité.", null)
    }
    return !this.context.confirmationForm ? true : this.context.confirmationForm.valid
  }

  protected checkEligibility(): boolean {
    const isEligible = this.isEligible()
    if (!isEligible) {
      this.actions.failWithMessage("Ce type de paiement n'est pas autorisé pour cet évenement.", null)
    }
    return isEligible
  }

  setUp(
    sessionDTO: SessionDTO,
    actions: SubscriptionConfirmationActions,
    context: SubscriptionConfirmationContext,
    referralCode: string) {

    this.sessionDTO = sessionDTO
    this.actions = actions;
    this.context = context;
    this.referralCode = referralCode
  }
  abstract pay(...args: Array<string>): Promise<MyPaypalTransactionInfo>
  abstract isEligible(): boolean

  setAuthByPhone(authByPhone: AuthByPhoneComponent) {
    this.authByPhone = authByPhone
  }


}

